import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {DialogsRepository} from '../repositories/dialogs.repository';

import {Answer, Dialog, DialogStats, ThesesStats} from '../model/model';

@Injectable()
export class DialogsService {

  constructor(private _dialogsRepository: DialogsRepository) { }

  public getDialogs(devoptions?:string): Observable<Array<Dialog>> {
      return this._dialogsRepository.getDialogs(devoptions);
  }

  public postDialogAnswers(answers: Array<Answer>): Observable<boolean> {
    return this._dialogsRepository.postDialogAnswers(answers);
  }

  public getTheses(): Observable<Array<Dialog>> {
    return this._dialogsRepository.getTheses();
  }

  public postThesisAnswer(thesisId: string, text: Dictionary<string>, value: number): Observable<boolean> {
    return this._dialogsRepository.postThesisgAnswer(thesisId, text, value);
  }

  public getThesesStats(name: string, date: Date | string, range: string, group: string): Observable<Array<ThesesStats>> {
    return this._dialogsRepository.getThesesStats(name, date, range, group);
  }

  public getDialogsStats(): Observable<DialogStats> {
    return this._dialogsRepository.getDialogsStats();
  }
}